
import {
  removeLocalStorageItem,
  setLocalStorageItem,
  retrieveLocalStorageItem,
} from 'utils/localStorage'

export const invalidTokenString = '-----invalid-token-----'

export const setToken = (tokenName, token, storageType = 'session') => {
  setLocalStorageItem(tokenName, token, storageType)
}

export const onboardingToken = () => retrieveLocalStorageItem('onboardingToken')
export const secureDocUploaderToken = () => retrieveLocalStorageItem('secureDocUploaderToken')
export const accessToken = () => retrieveLocalStorageItem('accessToken', 'local')
export const refreshToken = () => retrieveLocalStorageItem('refreshToken', 'local')

export const removeOnboardingToken = () => removeLocalStorageItem('onboardingToken')
export const removeSecureDocUploaderToken = () => removeLocalStorageItem('secureDocUploaderToken')
export const removeAccessToken = () => removeLocalStorageItem('accessToken', 'local')
export const removeRefreshToken = () => removeLocalStorageItem('refreshToken', 'local')

export const setInvalidOnboardingToken = () => setToken('onboardingToken', invalidTokenString)
export const setInvalidSecureDocUploaderToken = () => setToken('secureDocUploaderToken', invalidTokenString)
export const setInvalidAccessToken = () => setToken('accessToken', invalidTokenString, 'local')



// WEBPACK FOOTER //
// ./src/utils/tokens.js